import gql from 'graphql-tag'

export default gql`
  mutation course_projects_update_mutation(
    $id: ID!
    $description: String
    $finishedUrl: String
    $image: Upload
    # $files: [CourseAssetFileUpdateInput!]
    # $links: [CourseAssetLinkUpdateInput!]
    $slug: String!
    $title: String!
    $briefUrl: String
  ) {
    courseProjectUpdate(
      id: $id
      description: $description
      finishedUrl: $finishedUrl
      image: $image
      # files: $files
      # links: $links
      slug: $slug
      title: $title
      briefUrl: $briefUrl
    ) {
      id
    }
  }
`
